import styled from "styled-components";
import { useNavigate } from "react-router";
import SessionService from "../../../../../../services/session-service";
import { theme } from "../../../../../../helpers/theme";
import { ReactComponent as ForkliftWithRackSVG } from "../../../../../../assets/icons/forklift-with-rack.svg";
import Icon from "../../../../../../components/icon";
import { ViewVariantsTitle } from "../helpers/view-variants-title";
import { ViewVariantsArticle } from "../helpers/view-variants-article";
import { StyledButton } from "../../../../../../components/Button/button";
import { UnderlinedRedirect } from "../helpers/underlined-redirect";
import { urlClient } from "../../../../../../utils/url";
import { useEffect } from "react";


const title: string = "Nie znaleziono magazynów spełniających kryteria lub brak pojemności."

interface NoMatchingWarehousesProps {
    notatka_konsultanta?: string;
    //setIsComponentNoMatchingWarehousesVisible?: (value: boolean) => void;
    phone?: string;
}

export const NoMatchingWarehouses = ({
    notatka_konsultanta,
    phone,
    //setIsComponentNoMatchingWarehousesVisible 
}: NoMatchingWarehousesProps) => {
    const navigate = useNavigate();
    const loggedUserData = SessionService.getLoggedUserData()?SessionService.getLoggedUserData():null;

    // useEffect(() => {
    //     setIsComponentNoMatchingWarehousesVisible && setIsComponentNoMatchingWarehousesVisible(true);
    // }, []);

    return (
        <ViewWrapper>
            <IconWrapper>
                <Icon
                    width="184px"
                    height="147px"
                    icon={<ForkliftWithRackSVG />}
                />
            </IconWrapper>
            <ViewVariantsTitle
                title={title}
            />
            <ViewVariantsArticle
                phone={loggedUserData? loggedUserData.telefon : ""}
            />
            <ButtonWrapper>
                <StyledButton
                    onClick={() => navigate('/')}
                >
                    Ok, rozumiem
                </StyledButton >
                <UnderlinedRedirect
                    text={"Zmień kryteria"}
                    url={urlClient.orderForm}
                />
            </ButtonWrapper>
        </ViewWrapper>

    );
};

const ViewWrapper = styled.div`
display:flex;
flex-direction:column;
justyf-content:center;
`;
const IconWrapper = styled.div`
margin-left:auto;
margin-right:auto;
margin-top:48px;
`;
const ButtonWrapper = styled.div`
margin-left:auto;
margin-right:auto;
margin-bottom:40px;
margin-bottom:240px;
`;

const OfferFormCreateWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //   @media (max-width: ) {
  //     margin-top: 0px;
  //   }
`;
